<template>
	<div>
		<div style="margin-bottom: 5px">
			<el-input v-model="name" placeholder="请输入商品名称" suffix-icon="el-icon-a-042" style="width: 200px"
				@keyup.enter.native="loadPost"></el-input>
			<el-button type="primary" style="margin-left: 5px; font-size: 18px" @click="loadPost">
				查询</el-button>
			<el-button type="warning" @click="resetParam" style="font-size: 18px">
				重置</el-button>

			<el-button type="primary" style="margin-left: 5px; font-size: 18px" @click="printAll">
				打印订货单</el-button>

		</div>
		<div style="display: flex;flex-direction: row;">
			<div id="printInfo" style="width: 370px;padding-right: 0.125rem;">
				<span style="text-align: center;">{{formatTime(new Date())}}</span>
				<div style="padding-bottom: 0.3125rem;">................................................................................</div>
				<el-table :data="tableData" border :show-summary="showSummary" :summary-method="getSummaries">
					<!-- <el-table-column prop="id" label="ID" width="60"> </el-table-column> -->
					<!-- <el-table-column prop="userOrderNo" label="订货单号" ></el-table-column> -->
					<el-table-column prop="goodsName" label="名称" align="left" width="145"></el-table-column>
					<el-table-column prop="goodsNum" label="单价*数量" align="left" width="140">
						<template slot-scope="scope">
							{{scope.row.fee}} * {{scope.row.realGoodsNum?scope.row.realGoodsNum:scope.row.goodsNum}} {{scope.row.unit}}
						</template>
					</el-table-column>
					<el-table-column prop="totalMoney" label="总价(元)" :formatter="formatNumbers" align="left" width="80"></el-table-column>
				</el-table>
				<div>................................................................................</div>
				<h1 style="padding-top: 5px;">三跃商贸有限公司</h1>
				<h3 style="padding-top: 5px;">餐厅食材用料一站式配送</h3>
				<h3 style="padding-top: 5px;">联系电话：18339787266</h3>
				<h3 style="padding-top: 5px;">(微信同步):15346550777</h3>
			</div>
			<div class="container">
				<el-form ref="form" :model="form" label-width="150px" size="mini">
				    <el-form-item label="通信模式">
				        <el-select v-model="conModel" placeholder="请选择通信模式" @change="modelChange">
				            <el-option v-for="item in models" :key="item.value" :disabled="item.disabled"
				                :label="item.label" :value="item.value">
				            </el-option>
						</el-select>
				    </el-form-item>
				    <el-row>
				        <el-form-item label="网口信息" v-show="!isPortModel">
				            <el-col style="width: 150px">
				                <el-input type="text" placeholder="请输入ip地址" v-model="printForm.socketAddr"></el-input>
				            </el-col>
				            <el-col style="width: 120px;margin-left: 10px;">
				                <el-input type="number" placeholder="请输入端口" v-model="printForm.socketPort"></el-input>
				            </el-col>
				            <el-col style="width: 100px;margin-left: 40px;">
				                <el-button type="primary" @click="connectSokcet">连接网口</el-button>
				            </el-col>
				        </el-form-item>
				    </el-row>
				    <el-row>
				        <el-form-item label="端口信息" v-show="isPortModel">
				            <el-col style="width: 300px">
				                <el-input type="text" placeholder="请选择端口" :disable="true" v-model="printForm.selectName" :readonly="true" />
				            </el-col>
				            <el-col style="width: 100px;margin-left: 20px;">
				                <el-button type="primary" @click="choicePort">选择端口</el-button>
				            </el-col>
				        </el-form-item>
				    </el-row>
				    <el-form-item>
				        <el-button type="primary" :disabled="!connected" @click="sendPrintLable">二维码标签打印</el-button>
				    </el-form-item>
				</el-form>
			</div>
		</div>
	</div>

</template>

<script>
	import Print from "@/util/print.min.js"
	import Socket from "@/util/Socket";
	import NMPrintSocket from "@/util/Print";
	import gpTool from "@/util/function"
	import gpESC from "@/util/esc.js"
	import gpTSC from "@/util/tsc"
	import encodeToGb2312 from "@/util/encodeToGb2312.min.js"

	export default {
		name: "UserOrderInfo",
		data() {
			const jsonObj = {
			  printerImageProcessingInfo: {
			    printQuantity: 1,
			  },
			};
			return {
				models: [],
				conModel: '',
				isPortModel: true,
				connected: false,
				/** 网口配置 */
				websock: null,
				/** USB配置 */
				webusb: null,
				/** 串口配置 */
				webserial: null,
				printForm: {
				    selectName: '未连接',
				    socketAddr: '127.0.0.1',
				    socketPort: 8003,
				    printData: ''
				},
				
				baseUrl:this.$httpUrl+"/images/",
				baseUrlQrcode:this.$httpUrl+"/qrcode/",
				showSummary: true,
				tempGoods: {},
				tableData: [],
				printTable: [],
				pageSize: 10,
				pageNum: 1,
				total: 0,
				name: "",
				innerVisible: false,
				centerDialogVisible: false,
				orderInfoGoodsDialogVisible: false,
				voiceGoodsDialogVisible: false,
				editOrderInfoDialogVisible: false,
				form: {
					id: "",
					userId: "",
					userName: "",
					orderStatus: "1",
					remarks: ""
				},
				orderInfo: {
					id: "",
					userOrderId: "",
					userOrderNo: "",
					goodsId: "",
					goodsName: "",
					goodsNum: "",
					remarks: "",
					fee: "",
					unit: "",
					goodsStr: ""
				},
			};
		},
		props: {
			userOrderId: {
				type: Number,
				default: ""
			},
			userOrderNo: {
				type: String,
				default: ""
			},
			userName: {
				type: String,
				default: ""
			}
		},
		watch: {
			userOrderId: {
				handler(newVal, oldVal) {
					console.log("userOrderIdnewVal:" + newVal)
					if (newVal) {
						this.orderInfo.userOrderId = newVal;
						this.loadPost()
					}
				},
				deep: true,
				immediate: true
			},
			userOrderNo: {
				handler(newVal, oldVal) {
					console.log("userOrderNonewVal:" + newVal)
					if (newVal) {
						this.orderInfo.userOrderNo = newVal;
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {

					if (index === 0) {
						sums[index] = '合计';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (index == (columns.length - 1) && !values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] += '';
                        sums[index] = this.formatNumber(sums[index]);
					} else {
						sums[index] = '';
					}
				});

				return sums;
			},
            formatNumber(num) {
                return Number(num).toFixed(2);
            },
            formatNumbers(row,col){
                return this.formatNumber(row.totalMoney)
            },
			printAll() {
				printJS({
					printable: 'printInfo',
					type: 'html',
                    // 继承样式
                    // targetStyle: '*',
                    // targetStyles: '*',
                    // scanStyles: true,
                    // maxWidth: "1000",
					header: this.userName + '订货单',
					headerStyle: "width:320px;text-align: center;"
				})
			},
			
			
			
			// 二维码打印开始
			// 选择通讯模式
			async modelChange(value) {
			    const that = this;
			    if (value === 'USB') {
			        that.isPortModel = true;
			        //添加事件监听
			        await navigator.usb.addEventListener('connect', event => {
			            //重新连接成功
			            this.webusb = event.device;
			            that.printForm.selectName = event.device.productName;
			            that.$message.success('USB连接成功');
			            that.openWebUsb();
			        });
			        await navigator.usb.addEventListener('disconnect', event => {
			            //断开连接成功
			            that.printForm.selectName = '未连接';
			            that.connected = false;
			            that.$message.error('USB连接断开');
			        });
			        await navigator.usb.getDevices().then(devices => {
			            if (devices.length > 0) {
			                //找到前面选择的一个USB
			                that.webusb = devices[0];
			                that.printForm.selectName = devices[0].productName;
			                //打开usb
			                that.openWebUsb();
			            }
			        });
			    } else if (value === 'SERIAL') {
			        that.isPortModel = true;
			        //添加事件监听
			        await navigator.serial.addEventListener('connect', event => {
			            //重新连接成功
			            that.webserial = event.target;
			            console.log(serials[0].getInfo())
			            that.printForm.selectName = '串口连接成功';
			            this.$message.success('串口连接成功');
			            that.openWebSerial();
			        });
			        await navigator.serial.addEventListener('disconnect', event => {
			            //断开连接成功
			            that.printForm.selectName = '未连接';
			            that.connected = false;
			            this.$message.error('串口连接断开');
			        });
			        navigator.serial.getPorts().then(serials => {
			            if (serials.length > 0) {
			                that.webserial = serials[0];
			                console.log(serials[0].getInfo())
			                that.printForm.selectName = '串口连接成功';
			                that.openWebSerial();
			            }
			        });
			    } else {
			        this.isPortModel = false;
			    }
			},
			// 选择端口
			connectSokcet() {
			    const socketUrl = "ws://" + this.printForm.socketAddr + ":" + this.printForm.socketPort
			    this.websock = new WebSocket(socketUrl)
			    this.websock.onopen = this.websocketOnopen
			    this.websock.onerror = this.websocketOnerror
			    this.websock.onmessage = this.websocketOnmessage
			    this.websock.onclose = this.websocketOnclose
			    this.printForm.selectName = 'WebSocket连接成功'
			    this.$message.success('WebSocket连接成功')
			    console.log("网口准备就绪，可以进行读写")
			    this.connected = true
			},
			async choicePort() {
			    const that = this;
			    if (that.conModel === 'USB') {
			        await navigator.usb.requestDevice({ filters: [] })
			            .then(usb => {
			                // 业务逻辑处理
			                that.webusb = usb;
			                that.printForm.selectName = usb.productName;
			                that.openWebUsb();
			            }).catch(error => {
			                console.error("choicePort：" + error);
			            });
			    } else if (that.conModel === 'SERIAL') {
			        await navigator.serial.requestPort({ filters: [] })
			            .then(serial => {
			                that.webserial = serial;
			                that.printForm.selectName = serial.getInfo().usbVendorId;
			                that.openWebSerial();
			            }).catch(error => {
			                console.error("choicePort：" + error);
			            });
			    } else {
			        that.$message.error('请选择通信模式');
			    }
			},
			async openWebUsb() {
			    await this.webusb.open();
			    await this.webusb.selectConfiguration(1);
			    await this.webusb.claimInterface(0);
			    console.log("USB准备就绪，可以进行读写");
			    this.connected = true;
			},
			async sendPrintLable() {
				const url = window.location.href; // 获取当前页面的URL
				const urlParts = url.split('/'); // 使用'/'分割URL
				const host = urlParts[2]; // 第3部分通常包含IP和端口
				var data=this.tableData;
				var that=this;
				for (let item of data){
					//标签模式
					var command = this.createNew()
					// console.log(command)
					command.setSize(40, 30)
					command.setGap(2)
					command.setCls()
					command.setText(50, 10, "TSS24.BF2", 1, 1, item.goodsName) // 文本
					command.setQR(50, 50, "L", 5, "A", "http://"+host+"/orderInfo?orderInfoId="+item.id) // 二维码
					// command.setBar(50, 150, "128", 64, 1, 2, 4,"200902125410") // 二维码
					command.setPagePrint()
					await this.writePrintData(that.getDataView(command.getData()))
				}
			},
			
			async writePrintData(encodedCmds) {
			    //const encodedCmds = new Uint8Array(new TextEncoder().encode(this.form.printData))
			    if (this.conModel === 'USB') {
			        try {
			            await this.webusb.transferOut(
			                this.webusb.configuration.interfaces[0].alternate.endpoints.find(obj => obj.direction === 'out').endpointNumber, encodedCmds
			            );
			        } catch (error) {
			            this.$message.error('发送失败，请确认是否正常链接打印机')
			            // 如果任何操作失败，我们可以认为设备连接可能存在问题
			            console.error("sendPrint：", error);
			        }
			    } else if (this.conModel === 'SERIAL') {
			        try {
			            const writer = this.selectPort.writable.getWriter();
			            await writer.write(encodedCmds);
			            writer.releaseLock();
			        } catch (error) {
			            this.$message.error('发送失败，请确认是否正常链接打印机')
			            // 如果任何操作失败，我们可以认为设备连接可能存在问题
			            console.error("sendPrint：", error);
			        }
			    } else if (this.conModel === 'NET') {
			        try {
			            this.websock.send(encodedCmds)
			        } catch (error) {
			            this.$message.error('发送失败，请确认是否正常链接打印机')
			            // 如果任何操作失败，我们可以认为设备连接可能存在问题
			            console.error("sendPrint：", error);
			        }
			    }
			    this.$message.success("发送打印成功");
			},
			
			
			hexStringToByteArray(hexString) {
			    let byteArray = [];
			    for (let i = 0; i < hexString.length; i += 2) {
			        let byte = parseInt(hexString.substr(i, 2), 16);
			        byteArray.push(byte);
			    }
			    return byteArray;
			},
			getDataView(value) {
			    let uint8Buf = Array.from(value);
			    var encodedCmds = new ArrayBuffer(uint8Buf.length)
			    var dataView = new DataView(encodedCmds)
			    for (var j = 0; j < uint8Buf.length; j++) {
			        dataView.setUint8(j, uint8Buf[j]);
			    }
			    return encodedCmds;
			},
			createNew () {
			  var that=this;
			  var jpPrinter = {};
			  var data = "";
			  var command = []
			
			  jpPrinter.name = "标签模式";
			
			  jpPrinter.init = function () { };
			
			  jpPrinter.addCommand = function (content) {  //将指令转成数组装起
			      let printData = encodeToGb2312(content)
			      let code = that.hexStringToByteArray(printData)
			      for (var i = 0; i < code.length; ++i) {
			          command.push(code[i])
			      }
			  }
			
				/*
				* 设置标签大小
				* pageWidght 标签宽度(单位毫米)
				* pageHeight 标签高度(单位毫米)
				*/
			  jpPrinter.setSize = function (pageWidght, pageHeight) { 
			    data = "SIZE " + pageWidght.toString() + " mm" + "," + pageHeight.toString() + " mm" + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
				/*
				* 设置打印速度
				* printSpeed 速度值(范围1-6)
				*/
			  jpPrinter.setSpeed = function (printSpeed) {
			    data = "SPEED " + printSpeed.toString() + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setDensity = function (printDensity) { //设置打印机浓度
			    data = "DENSITY " + printDensity.toString() + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setGap = function (printGap) { //传感器
			    data = "GAP " + printGap.toString() + " mm\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setCountry = function (country) { //选择国际字符集
			    /*
			    001:USA
			    002:French
			    003:Latin America
			    034:Spanish
			    039:Italian
			    044:United Kingdom
			    046:Swedish
			    047:Norwegian
			    049:German
			     */
			    data = "COUNTRY " + country + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setCodepage = function (codepage) { //选择国际代码页
			    /*
			    8-bit codepage 字符集代表
			    437:United States
			    850:Multilingual
			    852:Slavic
			    860:Portuguese
			    863:Canadian/French
			    865:Nordic
			    Windows code page
			    1250:Central Europe
			    1252:Latin I
			    1253:Greek
			    1254:Turkish
			    以下代码页仅限于 12×24 dot 英数字体
			    WestEurope:WestEurope
			    Greek:Greek
			    Hebrew:Hebrew
			    EastEurope:EastEurope
			    Iran:Iran
			    IranII:IranII
			    Latvian:Latvian
			    Arabic:Arabic
			    Vietnam:Vietnam
			    Uygur:Uygur
			    Thai:Thai
			    1252:Latin I
			    1257:WPC1257
			    1251:WPC1251
			    866:Cyrillic
			    858:PC858
			    747:PC747
			    864:PC864
			    1001:PC100
			    */
			    data = "CODEPAGE " + codepage + "\r\n";
			    jpPrinter.addCommand(data)
			  }
			
			  jpPrinter.setCls = function () { //清除打印机缓存
			    data = "CLS" + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setFeed = function (feed) { //将纸向前推出n
			    data = "FEED " + feed + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setBackFeed = function (backup) { //将纸向后回拉n
			    data = "BACKFEED " + backup + "\r\n";
			    jpPrinter.addCommand(data)
			  }
			
			  jpPrinter.setDirection = function (direction) { //设置打印方向，参考编程手册  
			    data = "DIRECTION " + direction + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setReference = function (x, y) { //设置坐标原点，与打印方向有关
			    data = "REFERENCE " + x + "," + y + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setFromfeed = function () { //根据Size进一张标签纸
			    data = "FORMFEED \r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setHome = function () { //根据Size找到下一张标签纸的位置
			    data = "HOME \r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setSound = function (level, interval) { //控制蜂鸣器
			    data = "SOUND " + level + "," + interval + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setLimitfeed = function (limit) { // 检测垂直间距
			    data = "LIMITFEED " + limit + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setBar = function (x, y, width, height) { //绘制线条
			    data = "BAR " + x + "," + y + "," + width + "," + height + "\r\n"
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setBox = function (x_start, y_start, x_end, y_end, thickness) { //绘制方框
			    data = "BOX " + x_start + "," + y_start + "," + x_end + "," + y_end + "," + thickness + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setErase = function (x_start, y_start, x_width, y_height) { //清除指定区域的数据
			    data = "ERASE " + x_start + "," + y_start + "," + x_width + "," + y_height + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setReverse = function (x_start, y_start, x_width, y_height) { //将指定的区域反相打印
			    data = "REVERSE " + x_start + "," + y_start + "," + x_width + "," + y_height + "\r\n";
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setText = function (x, y, font, x_, y_, str) { //打印文字
			    data = "TEXT " + x + "," + y + ",\"" + font + "\"," + 0 + "," + x_ + "," + y_ + "," + "\"" + str + "\"\r\n"
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setQR = function (x, y, level, width, mode, content) { //打印二维码
			    data = "QRCODE " + x + "," + y + "," + level + "," + width + "," + mode + "," + 0 + ",\"" + content + "\"\r\n"
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setBar = function (x, y, codetype, height, readable, narrow, wide, content) { //打印条形码
			    data = "BARCODE " + x + "," + y + ",\"" + codetype + "\"," + height + "," + readable + "," + 0 + "," + narrow + "," + wide + ",\"" + content + "\"\r\n"
			    jpPrinter.addCommand(data)
			  };
			
			  jpPrinter.setBitmap = function (x, y, mode, res) {  //添加图片，res为画布参数
			    console.log(res)
			    var width = parseInt((res.width + 7) / 8 * 8 / 8)
			    var height = res.height;
			    var time = 1;
			    var temp = res.data.length - width * 32;
			    var pointList = []
			    console.log(width + "--" + height)
			    data = "BITMAP " + x + "," + y + "," + width + "," + height + "," + mode + ","
			    jpPrinter.addCommand(data)
			    for (var i = 0; i < height; ++i) {
			      console.log(temp)
			      for (var j = 0; j < width; ++j) {
			        for (var k = 0; k < 32; k += 4) {
			          if (res.data[temp] == 0 && res.data[temp + 1] == 0 && res.data[temp + 2] == 0 && res.data[temp + 3] == 0) {
			            pointList.push(1)
			          } else {
			            pointList.push(0)
			          }
			          temp += 4
			        }
			      }
			      time++
			      temp = res.data.length - width * 32 * time
			    }
			    for (var i = 0; i < pointList.length; i += 8) {
			      var p = pointList[i] * 128 + pointList[i + 1] * 64 + pointList[i + 2] * 32 + pointList[i + 3] * 16 + pointList[i + 4] * 8 + pointList[i + 5] * 4 + pointList[i + 6] * 2 + pointList[i + 7]
			      command.push(p)
			    }
			  }
			
			  jpPrinter.setPagePrint = function () { //打印页面
			    data = "PRINT 1,1\r\n"
			    jpPrinter.addCommand(data)
			  };
			  //获取打印数据
			  jpPrinter.getData = function () {
			    return command;
			  };
			
			  return jpPrinter;
			},
			// 二维码打印结束
			
			
			
			
			
			orderInfoState(row) {
				let temp = this.orderInfoStatus.find((item) => {
					return item.id == row.orderStatus;
				});

				return temp && temp.name;
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			resetParam() {
				this.name = "";
			},
			loadPost() {
				this.loadPostAll();
			},
			loadPostAll() {
				this.$axios
					.post(this.$httpUrl + "/userorderinfo/list", {
						userOrderId: this.userOrderId
					})
					.then((res) => res.data)
					.then((res) => {
						console.log(res);
						if (res.code == 200) {
							this.tableData = res.data;
						} else {
							alert("获取数据失败");
						}
					});
			},
			formatTime(date) {
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();
				let hours = date.getHours();
				let minutes = date.getMinutes();
				let seconds = date.getSeconds();

				month = month < 10 ? "0" + month : month;
				day = day < 10 ? "0" + day : day;
				hours = hours < 10 ? "0" + hours : hours;
				minutes = minutes < 10 ? "0" + minutes : minutes;
				seconds = seconds < 10 ? "0" + seconds : seconds;

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
		},

		beforeMount() {
			this.loadPost();
		},
		mounted() {
			//验证是否支持各类通信类型
			if (!'usb' in navigator) {
			    console.error('WebUSB API is not supported!')
			    this.models.push({ "value": "USB", "label": "USB", "disabled": true })
			} else {
			    this.models.push({ "value": "USB", "label": "USB", "disabled": false })
			}
			if (!'serial' in navigator) {
			    console.error('WebSerial API is not supported!')
			    this.models.push({ "value": "SERIAL", "label": "串口", "disabled": true })
			} else {
			    this.models.push({ "value": "SERIAL", "label": "串口", "disabled": false })
			}
			if (!"WebSocket" in window) {
			    console.error('WebSerial API is not supported!')
			    this.models.push({ "value": "NET", "label": "网口", "disabled": true })
			} else {
			    this.models.push({ "value": "NET", "label": "网口", "disabled": false })
			}
			
		}
	};
</script>


<style  scoped>
.container {
  width: 700px;
  margin: 0 auto;

  h1 {
    text-align: center;
  }

  h3 {
    text-align: left;
  }

  .content {
    border: solid 1px #ced4da;
    padding: 8px;
    text-align: left;
  }

  button {
    margin-left: 8px;
    margin-right: 0px;
    display: inline;
    padding: 8px;
    background-color: #409eff;
    border-color: #409eff;
    border: 1px;
    border-radius: 4px;
    color: #fff;
  }

  button:hover {
    background-color: #75baff;
    border-color: #75baff;
  }

  button:active {
    background-color: #1866b4;
    border-color: #1866b4;
  }

  span {
    color: red;
    font-style: italic;
    font-weight: bold;
    text-decoration: underline;
  }

  .status {
    display: inline;
  }

  .service_status,
  .init_status,
  .connect_usb .usb_printer_connect_status,
  .connect_wifi .wifi_printer_connect_status,
  .select_usb .select_printer,
  .select_wifi .select_printer {
    border: solid 1px #ced4da;
    background-color: #e9ecef;
    border-radius: 4px;
    font-size: 14px;
    padding: 6px;
  }

  .service,
  .init,
  .select_usb,
  .select_wifi,
  .connect_usb,
  .connect_wifi,
  .wifi_printer_setting,
  .wifi_printer_setting .setOrGet,
  .print {
    margin-top: 16px;
  }

  .print_label {
    margin-left: 10px;
    margin-top: 8px;
  }

  #wifi_password {
    margin-left: 16px;
  }
}


</style>
